import React from 'react';
import { ReferralDashboard } from './pages/ReferralDashboard';
export function App() {
  return <ReferralDashboard data-id="element-0" />;
}